var $2d125e0b34676352$exports = {};
$2d125e0b34676352$exports = {
  "buttonLabel": "Prika\u017Ei prijedloge",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcije/a");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Unesena skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcijom");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcije/a");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", odabranih",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Prijedlozi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", odabrano");
  }
};
export { $2d125e0b34676352$exports as default };